// extracted by mini-css-extract-plugin
module.exports = {"QuickSearch":"QuickSearch_QuickSearch_3hGAB"};